module.exports = __webpack_public_path__ + "static/ozaken_AI-532cb5c62d2d8fa4732bd071d9e7f478.jpg";